import { createSelector } from 'reselect';
import { selectCurrentInstance, selectContentTypeColumns } from 'structured-content-lib/redux/selectors/instanceEditSelectors';
// @ts-expect-error not typed
import { createUpdateFocusedItem } from 'ContentEditorUI/redux/actions/baseFocusActions';
// @ts-expect-error not typed
import { openModal } from 'ContentEditorUI/redux/actions/appActions';
// @ts-expect-error not typed
import { setScrollTo } from 'ContentEditorUI/redux/actions/baseSettingsActions';
import { SETTINGS_MODAL } from '../../constants';
export const selectInstanceUrl = createSelector([selectCurrentInstance], instance => {
  if (instance) {
    return instance.values.hs_absolute_url;
  }
  return null;
});
const instanceFocusLogic = (focusedItem, dispatch, state, options) => {
  const contentTypeSchemaColumns = selectContentTypeColumns(state);
  contentTypeSchemaColumns.find(column => {
    if (column.name === focusedItem) {
      dispatch(openModal(SETTINGS_MODAL));
      dispatch(setScrollTo(options.settingsModalQuery));
    }
    return false;
  });
};
export const updateFocusedItem = createUpdateFocusedItem(instanceFocusLogic);